const enums = { reservationStatus: ['Reserved', 'Cancelled', 'MovedIn'] };

export default enums;
